<template>
  <div id="document-sidebar" class="py-6">
    <VuePerfectScrollbar :style="{maxHeight: scrollHeight}" :settings="scrollbarSettings">
    <!-- 新規登録ボタン -->
    <div class="clearfix px-6 pb-4">
      <add-button></add-button>
    </div>
    
    
      <!-- ツリー -->
      <div class="pt-2 pb-4">
        <folder-tree-list />
      </div>

      <!-- 重要・最近更新されたファイル・ゴミ箱 -->
      <div class="sidebar-item pb-4">
        <div
          class="px-6 py-2 flex items-center cursor-pointer"
          :class="{ selected: isSelected('important') }"
          @click="showImportantDocuments"
        >
          <feather-icon icon="StarIcon" svgClasses="h-6 w-6"></feather-icon>
          <span class="ml-4">重要</span>
        </div>

        <div
          class="px-6 py-2 flex items-center cursor-pointer"
          :class="{ selected: isSelected('latest') }"
          @click="showLatestDocuments"
        >
          <feather-icon icon="ClockIcon" svgClasses="h-6 w-6"></feather-icon>
          <span class="ml-4">最近更新された書類</span>
        </div>

        <!-- ゴミ箱は実装を見送るため非表示 -->
        <!-- <div class="px-6 py-2 flex items-center">
          <feather-icon icon="TrashIcon" svgClasses="h-6 w-6"></feather-icon>
          <span class="ml-4">ゴミ箱</span>
        </div> -->
      </div>

      <!-- 種類別 -->
      <div class="px-6 title-label-gray">種類別</div>
      <div class="sidebar-item pb-4 flex flex-col cursor-pointer">
        <div
          class="px-6 py-2 flex items-center"
          v-for="item in kindList"
          :key="item.kind"
          @click="toggleFetchKind(item)"
          :class="{ 'sidebar-item-selected': isSelected(item.kind) }"
        >
          <!-- アイコン -->
          <document-icon :type="item.kind" svgClasses="w-6 h-6"></document-icon>
          
          <span class="ml-4">
            {{ item.text }}
          </span>
        </div>
      </div>

      <!-- ストレージ -->
      <div class="pb-6">
        <div class="px-6 b-6 title-label-gray">ストレージ情報</div>
        <storage-view></storage-view>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import { DOCUMENT_KIND, DOCUMENT_SIDEBAR_KIND } from "@/config/const";
import { ColorMixin, DocumentMixin } from "@/mixins";
import AddButton from "./components/DocumentSidebarAddButton"
import FolderTreeList from "./components/tree/DocumentFolderTreeList";
import StorageView from "./components/DocumentSidebarStorageView";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { createNamespacedHelpers } from "vuex";
import DocumentIcon from "../icon/DocumentIcon";

const {
  mapActions: mapActionsOfEnterpriseDocumentManager,
  mapMutations: mapMutationsOfEnterpriseDocumentManager,
  mapState: mapStateOfEnterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");


export default {
  mixins: [ColorMixin, DocumentMixin],
  components: {
    AddButton,
    FolderTreeList,
    StorageView,
    DocumentIcon,
    VuePerfectScrollbar
  },
  data () {
    return {
      kindList: [
        { kind: DOCUMENT_KIND.IMAGE, text: "画像ファイル" },
        { kind: DOCUMENT_KIND.VIDEO, text: "動画ファイル" },
        { kind: DOCUMENT_KIND.PDF, text: "PDFファイル" },
        { kind: DOCUMENT_KIND.WORD, text: "Wordファイル" },
        { kind: DOCUMENT_KIND.EXCEL, text: "Excelファイル" },
        { kind: DOCUMENT_KIND.POWERPOINT, text: "PowerPointファイル" },
        { kind: DOCUMENT_KIND.OTHER, text: "その他ファイル" }
      ],
    }
  },
  computed: {
    ...mapStateOfEnterpriseDocumentManager([
      "selectedSidebarItem", "showFolderList"
    ]),
    selectedItem: {
      get () { return this.selectedSidebarItem },
      set (item) { this.SET_SELECTED_SIDEBAR_ITEM(item) }
    },
    scrollHeight() {
      return `${this.$store.state.windowHeight - 200}px`
    },
  },
  methods: {
    ...mapMutationsOfEnterpriseDocumentManager([
      "SET_SELECTED_SIDEBAR_ITEM",
      "SET_SELECTED_SIDEBAR_TEXT"
    ]),
    ...mapActionsOfEnterpriseDocumentManager([
      "fetchDocumentsKind",
      "fetchImportantDocuments",
      "fetchLatestDocuments",
      "setSidebarSelected"
    ]),
    async showImportantDocuments () {
      try {
        this.$vs.loading();
        const payload = { selected: DOCUMENT_SIDEBAR_KIND.IMPORTANT, showPath: true, showFolder: false }
        await this.setSidebarSelected(payload)
        await this.fetchImportantDocuments()
        this.SET_SELECTED_SIDEBAR_TEXT("重要書類")
        this.$vs.loading.close();
      } catch (error) {
        console.error(error)
        this.$vs.loading.close();
        this.$vs.notify({
          title: "重要書類の取得に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
      }
    },
    async showLatestDocuments () {
      try {
        this.$vs.loading();
        const payload = { selected: DOCUMENT_SIDEBAR_KIND.LATEST, showPath: true, showFolder: false }
        await this.setSidebarSelected(payload)
        await this.fetchLatestDocuments()
        this.SET_SELECTED_SIDEBAR_TEXT("最近更新された書類")
        this.$vs.loading.close();
      } catch (error) {
        console.error(error)
        this.$vs.loading.close();
        this.$vs.notify({
          title: "最近更新されたファイルの取得に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
      }
    },
    async toggleFetchKind (item) {
      try {
        this.$vs.loading();
        const payload = { selected: item.kind, showPath: true, showFolder: false }
        await this.setSidebarSelected(payload)
        await this.fetchDocumentsKind(item.kind)
        this.SET_SELECTED_SIDEBAR_TEXT(item.text)
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "種類別ファイルの取得に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
      }
    },
    isSelected (item) {
      return item === this.selectedSidebarItem
    }
  },
  mounted() {
    this.SET_SELECTED_SIDEBAR_ITEM("tree-root")
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/document-manager.scss";

#document-sidebar {
  .tree-scroll-area {
    max-height: 20vh;
  }

  .title-label-gray {
    font-size: 12px;
    color: $aisea-gray;
  }
}
</style>